export class IdP {
    id: number;
    domainNames: string;
    protocol: string;
    name: string;
    userProvisioning: boolean;
    createdAt: Date;
    updatedAt: Date;

    constructor() {
        this.id = 0;
        this.domainNames = '';
        this.protocol = '';
        this.name = '';
        this.userProvisioning = false;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}